import { ErrorMessage } from '@hookform/error-message';
import { Info } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { Tooltip } from '../Tooltip';

type FileInputFormProps = {
  label: string;
  name: string;
  tooltip?: string;
  accept?: string;
};

export function FileInputForm({
  label,
  name,
  tooltip,
  accept,
}: FileInputFormProps) {
  const { register, formState } = useFormContext();
  const { errors } = formState;

  return (
    <div>
      <label className="relative block w-full">
        <span className="text-md mb-2 flex items-center gap-2 font-medium text-gray-900 dark:text-white">
          {label}
          {tooltip && (
            <Tooltip message={tooltip}>
              <Info size={16} className="text-blue-600" />
            </Tooltip>
          )}
        </span>

        <input
          type="file"
          className="block w-full text-sm text-gray-500 file:me-4 file:rounded-lg file:border-0 file:bg-blue-600 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-white hover:file:bg-blue-700 file:disabled:pointer-events-none file:disabled:opacity-50"
          accept={accept}
          {...register(name)}
        />
      </label>

      <ErrorMessage
        name={name}
        errors={errors}
        render={({ message }) => (
          <p className="mt-2 text-sm text-red-600">{message}</p>
        )}
      />
    </div>
  );
}
